// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import FeaturesPage from "../pages/Features/Features";
const __wvcRoutePaths = ["/FeaturesPage", "/features"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["contact", "contactpage", "features", "featurespage", "home", "homepage", "post", "support", "supportpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      <Route path={__wvcRoutePaths[0]} element={<FeaturesPage />} />
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<FeaturesPage />} />
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
